
import React from 'react';
import BasicRoute from '../router';
import { SnackbarProvider } from 'notistack'
import { SnackbarUtilsConfigurator } from '../component/common/snackbar';
import './app.page.scss'
import { ThemeProvider } from '@mui/material/styles';
import { GlobalCss } from '../themes/customization'
import { observer } from 'mobx-react-lite';
import { AppPageState } from './app.state';
import { reaction } from 'mobx';
import { MobxObjectsManager, useManualRemove } from './mobx-objs/mobx-manager';
import i18next from 'i18next';
import { HashRouter } from '../router/react-router-v5-compat';

export const userData = MobxObjectsManager.get(AppPageState);
reaction(
    () => userData.language,
    locale => {
        i18next.changeLanguage(locale);
    }
);

const AppPage = observer(() => {
    useManualRemove(AppPageState);

    React.useEffect(() => {
        userData.setConfig();
        return () => { userData.destroy() }
    }, [])

    /**
     * 插入样式
     */
    const InsertCSS = () => {
        switch (userData.themesMode) {
            case 'dark':
                return <GlobalCss.dark />
            default:
                return <GlobalCss.light />
        }
    }

    return (
        <div className='App'>
            <ThemeProvider theme={userData.theme} >
                {<InsertCSS />}
                <SnackbarProvider
                    maxSnack={5}>
                    <SnackbarUtilsConfigurator />
                    {
                        <HashRouter >
                            <BasicRoute />
                        </HashRouter>
                    }
                </SnackbarProvider>
            </ThemeProvider>
        </div >
    )
});

export default AppPage;